import { render } from 'preact';

import { App } from './app';
import { createApi } from './api';
import './styles.css';

render(<App api={createApi()} />, document.getElementById('app') as HTMLElement);

// Damit die Anwendung auch ohne Netz startet. Fehlschläge werden bewusst
// verschluckt: ein Gerät ohne Service-Worker-Unterstützung soll trotzdem
// arbeiten können.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
